import React from 'react';
import { MetricCard } from '../components/dashboard/MetricCard';
import { PerformanceDistribution } from '../components/dashboard/PerformanceDistribution';
import { ActivityHealth } from '../components/dashboard/ActivityHealth';
import { RiskSignals } from '../components/dashboard/RiskSignals';
import { LOBreakdownTable } from '../components/dashboard/LOBreakdownTable';
import { BuildingIcon, CalendarIcon } from 'lucide-react';
export function CEOCommandCenter() {
  const currentDate = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <div className="min-h-screen bg-slate-900 text-slate-100 font-sans selection:bg-blue-500/30" data-id="element-131">
      {/* Header Bar */}
      <header className="bg-slate-900 border-b border-slate-800 sticky top-0 z-10 backdrop-blur-sm bg-opacity-90" data-id="element-132">
        <div className="max-w-[1600px] mx-auto px-6 py-4 flex justify-between items-center" data-id="element-133">
          <div className="flex items-center gap-4" data-id="element-134">
            <div className="bg-blue-600 p-2 rounded-lg shadow-lg shadow-blue-900/20" data-id="element-135">
              <BuildingIcon className="w-6 h-6 text-white" data-id="element-136" />
            </div>
            <div data-id="element-137">
              <h1 className="text-xl font-bold text-white tracking-tight" data-id="element-138">
                CEO Command Center
              </h1>
              <p className="text-xs text-blue-400 font-medium uppercase tracking-wider" data-id="element-139">
                Pinnacle Mortgage Group
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 text-slate-400 bg-slate-800/50 px-4 py-2 rounded-full border border-slate-700/50" data-id="element-140">
            <CalendarIcon className="w-4 h-4" data-id="element-141" />
            <span className="text-sm font-medium" data-id="element-142">{currentDate}</span>
          </div>
        </div>
      </header>

      <main className="max-w-[1600px] mx-auto px-6 py-8 space-y-8" data-id="element-143">
        {/* Section 1: Revenue Health Metrics */}
        <section data-id="element-144">
          <h2 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-145">
            <span className="w-2 h-2 bg-emerald-500 rounded-full" data-id="element-146"></span>
            Revenue Health
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4" data-id="element-147">
            <MetricCard title="Funded Vol (MTD)" value="$42.8M" subValue="Goal: $50M" progress={85.6} status="success" trend="up" trendValue="+12%" data-id="element-148" />
            <MetricCard title="Locked Vol" value="$38.2M" subValue="Goal: $45M" progress={84.8} status="warning" trend="down" trendValue="-3%" data-id="element-149" />
            <MetricCard title="Pipeline Coverage" value="3.2x" subValue="Healthy: >3.0x" status="success" trend="up" trendValue="0.2x" data-id="element-150" />
            <MetricCard title="Pull-to-Fund" value="68.4%" subValue="Industry: 65%" status="success" trend="up" trendValue="+2.1%" data-id="element-151" />
            <MetricCard title="Rev per LO" value="$12,450" subValue="Monthly Avg" status="warning" trend="neutral" trendValue="0%" data-id="element-152" />
            <MetricCard title="Rev per Employee" value="$8,200" subValue="Operational Efficiency" status="success" trend="up" trendValue="+5%" data-id="element-153" />
          </div>
        </section>

        {/* Section 2: Middle Layout (Performance & Risk) */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-id="element-154">
          {/* Left Column: Performance Distribution (5 cols) */}
          <div className="lg:col-span-5 flex flex-col h-full" data-id="element-155">
            <PerformanceDistribution data-id="element-156" />
          </div>

          {/* Right Column: Activity & Risk (7 cols) */}
          <div className="lg:col-span-7 flex flex-col gap-6" data-id="element-157">
            <ActivityHealth data-id="element-158" />
            <div className="flex-1" data-id="element-159">
              <RiskSignals data-id="element-160" />
            </div>
          </div>
        </div>

        {/* Section 3: Detailed Breakdown */}
        <section data-id="element-161">
          <LOBreakdownTable data-id="element-162" />
        </section>
      </main>
    </div>;
}